import type { NextPage } from 'next';

import Login from '@components_common/auth/Login';

const CompanyLoginPage: NextPage = () => {
  return <Login userType={'company'} />;
};

export default CompanyLoginPage;
